import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { HeadlineM } from '#src/atoms/typography/index.tsx';
import { Dialog } from '#src/components/dialog/index.tsx';
import { useScreenSize } from '#src/hooks/device/useScreenSize.ts';
import { glossary } from '#src/lib/glossary.ts';
import { TextDocument } from '#src/routing/TextDocument/lazy.tsx';

const Content = styled.div`
  padding: var(--triple-unit);
  margin: 0 calc(-1 * var(--unit));
`;

type Terms =
  | 'boostedCreditTerms'
  | 'referralTerms'
  | 'loanTerms'
  | 'duoMissionTerms'
  | 'creditTerms'
  | 'terms'
  | 'quickPlayTerms'
  | 'setReferralTerms';

const messages = defineMessages<Terms>({
  terms: {
    defaultMessage: 'DISCOUNT_CREDIT_TERMS.md',
  },
  referralTerms: {
    defaultMessage: 'DISCOUNT_REFERRAL_CREDIT_TERMS.md',
  },
  loanTerms: {
    defaultMessage: 'LOAN_OFFER_TERMS.md',
  },
  creditTerms: {
    defaultMessage: 'CREDIT_TERMS.md',
  },
  boostedCreditTerms: {
    defaultMessage: 'BOOSTED_CREDIT_TERMS.md',
  },
  duoMissionTerms: {
    defaultMessage: 'DUO_MISSION_TERMS.md',
  },
  quickPlayTerms: {
    defaultMessage: 'QUICK_PLAY_RULES.md',
  },
  setReferralTerms: {
    defaultMessage: 'SET_REFERRAL_TERMS.md',
  },
});

type Props = {
  terms?: Terms;
  fileName?: string;
  onClose: () => void;
};
export const TermsDialog = ({ terms = 'terms', fileName, onClose }: Props) => {
  const { formatMessage } = useIntl();
  const { up: isLaptop } = useScreenSize('laptop');
  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open
      onClose={onClose}
      fullScreen={!isLaptop}
      title={
        <HeadlineM className="text-center" as="h3">
          <FormattedMessage defaultMessage="Terms & conditions" />
        </HeadlineM>
      }
      footer={
        <Button fullWidth size="medium" color="secondary" onClick={onClose}>
          <FormattedMessage {...glossary.ok} />
        </Button>
      }
    >
      <Content dir="ltr">
        <TextDocument document={fileName || formatMessage(messages[terms])} />
      </Content>
    </Dialog>
  );
};
